import { RocketLaunch } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ExerciseInterface } from "../../../../interfaces/examInterfaces";
import { useSelector } from "react-redux";
import { RootState } from "../../../..";
import {
  BoxNumber,
  BoxNumberPoints,
  BoxNumberRocket,
  BoxTitleExercise,
  ExerciseContainer,
  ExerciseImage,
  ExerciseNumber,
  PointsContainerPdf,
  PointsPdf,
  Rocket,
  SpacerLeft,
} from "./PizLinardStyles";

export const PizLinardPDFExercise = ({
  exercise,
  imageUrl,
  solutionImageUrl,
  zoomFactor,
}: {
  exercise: ExerciseInterface;
  imageUrl: string;
  solutionImageUrl: string;
  zoomFactor: number;
}) => {
  const showSolutions = useSelector((state: RootState) => state.examBuilder.main.showSolutions);

  return (
    <>
      <Box>
        <ExerciseContainer zoomfactor={zoomFactor}>
          <SpacerLeft zoomfactor={zoomFactor}></SpacerLeft>
          <BoxTitleExercise zoomfactor={zoomFactor}>
            <BoxNumberPoints zoomfactor={zoomFactor}>
              <BoxNumberRocket zoomfactor={zoomFactor}>
                <BoxNumber zoomfactor={zoomFactor}>
                  <ExerciseNumber zoomfactor={zoomFactor}>Aufgabe {exercise.index + 1}</ExerciseNumber>
                </BoxNumber>
                {exercise.level === 3 && (
                  <Rocket zoomfactor={zoomFactor}>
                    <RocketLaunch />
                  </Rocket>
                )}
              </BoxNumberRocket>
              <PointsContainerPdf zoomfactor={zoomFactor}>
                <PointsPdf zoomfactor={zoomFactor}>/ {exercise.points}</PointsPdf>
              </PointsContainerPdf>
            </BoxNumberPoints>
            <ExerciseImage zoomfactor={zoomFactor}>
              <img src={showSolutions ? solutionImageUrl : imageUrl} alt="" />
            </ExerciseImage>
          </BoxTitleExercise>
        </ExerciseContainer>
      </Box>
    </>
  );
};

export default PizLinardPDFExercise;
